import React from "react";

import { LinkListBlock } from "@reactivated";

import { Clickable } from "../Clickables";
import { H, HLevel } from "../Headings";

import styles from "./LinkList.module.scss";

export const LinkList = ({ value }: { value: LinkListBlock }) => {
    const root = React.useRef<HTMLUListElement>(null);
    const [firsts, setFirsts] = React.useState([0]);

    React.useEffect(() => {
        const observer = new ResizeObserver(() => {
            const result = [] as number[];
            let currentLineTop: null | number = null;
            // check each li in order
            for (const [i, el] of Object.entries(
                root.current!.querySelectorAll("li"),
            )) {
                // If this is the first time we've seen this "y" value,
                // this element must be the first one on the line
                const top = el.getBoundingClientRect().y;
                if (top !== currentLineTop) {
                    result.push(parseInt(i));
                    currentLineTop = top;
                }
            }
            setFirsts(result);
        });
        observer.observe(root.current!);
        return () => observer.disconnect();
    }, []);

    return (
        <HLevel>
            <section className={styles.wrapper}>
                {value.title && <H className={styles.title}>{value.title}</H>}
                <ul ref={root} className={styles.root}>
                    {value.links?.map((block, i) => (
                        <li key={block.id}>
                            <Clickable
                                href={block.value.url ?? ""}
                                data-first-of-line={firsts.includes(i)}
                                className={styles.link}
                            >
                                {block.value.display_name}
                            </Clickable>
                        </li>
                    ))}
                </ul>
            </section>
        </HLevel>
    );
};
